// Copyright (c) 2018 Deere & Company

const isSaveDisabled = (layoutName, isLayoutNameValid, selectedColumns) =>
    !layoutName || !isLayoutNameValid || !selectedColumns.length;

export default isSaveDisabled;



// WEBPACK FOOTER //
// ./src/shared/components/excel-layout/services/is-save-disabled.js